import React from 'react';
import { Phone } from 'lucide-react';
import { useApp } from '../context/AppContext';

export const WA_NUMBER = '41791772424';
export const PHONE_DISPLAY = '+41 79 177 24 24';
const TEXT = {
  de: 'Hallo CAB.TAXI, ich möchte einen Transfer anfragen.',
  en: 'Hello CAB.TAXI, I would like to request a transfer.',
  fr: 'Bonjour CAB.TAXI, je souhaite demander un transfert.',
  it: 'Ciao CAB.TAXI, vorrei richiedere un transfer.',
};

export const waLink = (text) => `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;

const WhatsAppIcon = ({ className }) => (
  <svg viewBox="0 0 32 32" className={className} fill="currentColor" aria-hidden="true">
    <path d="M16.004 3C8.83 3 3 8.83 3 16.004c0 2.29.6 4.53 1.74 6.5L3 29l6.68-1.72a12.96 12.96 0 0 0 6.32 1.64h.01C23.18 28.92 29 23.1 29 15.93 29 8.83 23.18 3 16.004 3zm0 23.73h-.01a10.75 10.75 0 0 1-5.48-1.5l-.39-.23-3.96 1.02 1.06-3.86-.26-.4a10.72 10.72 0 0 1-1.65-5.75c0-5.94 4.84-10.78 10.79-10.78 2.88 0 5.59 1.12 7.63 3.16a10.7 10.7 0 0 1 3.15 7.62c0 5.95-4.84 10.78-10.78 10.78zm5.91-8.07c-.32-.16-1.92-.95-2.21-1.05-.3-.11-.51-.16-.73.16-.21.32-.83 1.05-1.02 1.26-.19.21-.37.24-.7.08-.32-.16-1.37-.5-2.6-1.6-.96-.86-1.61-1.92-1.8-2.24-.19-.32-.02-.5.14-.66.15-.15.32-.37.49-.56.16-.19.21-.32.32-.54.11-.21.05-.4-.03-.56-.08-.16-.73-1.75-1-2.4-.26-.63-.53-.54-.73-.55h-.62c-.21 0-.56.08-.86.4-.3.32-1.13 1.1-1.13 2.69s1.16 3.12 1.32 3.34c.16.21 2.28 3.48 5.52 4.88.77.33 1.37.53 1.84.68.77.25 1.48.21 2.03.13.62-.09 1.92-.78 2.19-1.54.27-.75.27-1.4.19-1.54-.08-.13-.3-.21-.62-.37z" />
  </svg>
);

// Floating contact buttons: call + WhatsApp (official logo). Route text is appended on route pages.
const WhatsAppButton = () => {
  const { lang, waText } = useApp();
  const base = TEXT[lang] || TEXT.en;
  return (
    <div className="fixed bottom-5 right-5 z-[60] flex flex-col items-center gap-3" data-testid="floating-contact" data-no-translate>
      <a href={`tel:+${WA_NUMBER}`} aria-label={PHONE_DISPLAY} title={PHONE_DISPLAY} data-testid="call-button"
        className="flex items-center justify-center w-14 h-14 rounded-full text-white shadow-xl transition-transform hover:scale-105" style={{ backgroundColor: 'var(--brand-dark)' }}>
        <Phone className="w-7 h-7" style={{ color: 'var(--brand-accent)' }} />
      </a>
      <a href={waLink(waText ? `${base}\n${waText}` : base)} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" data-testid="whatsapp-button"
        className="relative flex items-center justify-center w-14 h-14 rounded-full text-white shadow-xl transition-transform hover:scale-105" style={{ backgroundColor: '#25D366' }}>
        <span className="absolute inset-0 rounded-full animate-ping opacity-30" style={{ backgroundColor: '#25D366' }} />
        <WhatsAppIcon className="w-8 h-8 relative" />
      </a>
    </div>
  );
};

export default WhatsAppButton;
